import type { TranslationLanguage } from '@/types/domain';
import {
  TranslationPillGroup,
  TranslationPill,
} from '@/components/ui/TranslationPillGroup';

type Option = { value: TranslationLanguage; label: string };

const OPTIONS: Option[] = [
  { value: 'en', label: 'English' },
  { value: 'ur', label: 'Urdu' },
  { value: 'both', label: 'Both' },
  { value: 'none', label: 'Arabic only' },
];

type TranslationLanguageToggleProps = {
  value: TranslationLanguage;
  onChange: (next: TranslationLanguage) => void;
};

/**
 * Segmented control for translation language preference. Drives whether
 * `ayahs.translation_en` and/or `ayahs.translation_ur` render under each ayah.
 */
export function TranslationLanguageToggle({
  value,
  onChange,
}: TranslationLanguageToggleProps) {
  return (
    <TranslationPillGroup ariaLabel="Translation language">
      {OPTIONS.map((opt) => (
        <TranslationPill
          key={opt.value}
          active={opt.value === value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </TranslationPill>
      ))}
    </TranslationPillGroup>
  );
}